import { sequence, trigger, stagger, animate, state, style, group, query, transition, keyframes, animateChild } from '@angular/animations';
import { AnimationTriggerMetadata } from '@angular/animations';

export const slideToBottomTransition: AnimationTriggerMetadata = trigger('slideToBottomTransition', [
  transition('catalogs => *, ads => settings', [
    query(':leave, :enter', style({ position: 'absolute', width: '100%' })),
    sequence([
      query(':leave', animateChild()),
      group([
        query(':leave', [
          style({ top: '0' }), animate('500ms ease-in-out', style({ top: '-100%' })),
        ]),
        query(':enter', [
          style({ top: '100%' }), animate('500ms ease-in-out', style({ top: '0' })),
        ]),
      ]),
      query(':enter', animateChild())
    ])
  ]),
  transition('settings => *, ads => catalogs', [
    query(':leave, :enter', style({ position: 'absolute', width: '100%' })),
    sequence([
      query(':leave', animateChild()),
      group([
        query(':leave', [
          style({ top: '0' }), animate('500ms ease-in-out', style({ top: '100%' })),
        ]),
        query(':enter', [
          style({ top: '-100%' }), animate('500ms ease-in-out', style({ top: '0' })),
        ]),
      ]),
      query(':enter', animateChild())
    ])
  ])
]);

export const slideToLeftTransition: AnimationTriggerMetadata = trigger('slideToLeftTransition', [
  transition('catalogs-list => catalogs-create, ads-list => ads-create', [
    query(':enter, :leave', style({ position: 'absolute', width: '100%' })),
    sequence([
      query(':leave', animateChild()),
      group([
        query(':leave', [style({ left: '0' }), animate('500ms ease-in-out', style({ left: '-100%' })),
        ]),
        query(':enter', [
          style({ left: '100%' }), animate('500ms ease-in-out', style({ left: '0' })),
        ])
      ]),
      query(':enter', animateChild())
    ])
  ]),
  transition('catalogs-create => catalogs-list,ads-create => ads-list', [
    query(':enter, :leave', style({ position: 'absolute', width: '100%' })),
    sequence([
      query(':leave', animateChild()),
      group([
        query(':leave', [style({ left: '0' }), animate('500ms ease-in-out', style({ left: '100%' })),
        ]),
        query(':enter', [
          style({ left: '-100%' }), animate('500ms ease-in-out', style({ left: '0' })),
        ])
      ]),
      query(':enter', animateChild())
    ])
  ])
]);

export const mainTransition: AnimationTriggerMetadata = trigger('mainTransition', [
  transition('* => *', [
    query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),
    query(':enter .sidebar-wrapper', style({ left: '-100%' }), { optional: true }),
    query(':enter .main-content', style({ left: '100%' }), { optional: true }),
    query('.floating-toolbar', style({ opacity: 0 }), { optional: true }),
    // query('.preview', style({opacity: 0}), { optional: true }),
    sequence([
      query(':leave', [
        group([
          query('.preview', [
            style({ opacity: 1 }),
            animate('200ms',
              style({ opacity: 0 })),
          ], { optional: true }),
          query('.sidebar-wrapper', [
            style({ left: '0' }),
            animate('200ms 500ms ease-in-out',
              style({ left: '-100%' })),
          ], { optional: true }),
          query('.main-content', [
            style({ left: '0' }),
            animate('200ms 500ms ease-in-out',
              style({ left: '100%' })),
          ], { optional: true })
        ])
      ], { optional: true }),
      query(':enter', [
        sequence([
          group([
            query('.sidebar-wrapper', [
              style({ left: '-100%' }),
              animate('500ms ease-in-out',
                style({ left: '0' })),
            ], { optional: true }),
            query('.main-content', [
              style({ left: '100%' }),
              animate('500ms ease-in-out',
                style({ left: '0' })),
            ], { optional: true }),
          ]),
          group([
            query('.floating-toolbar', [
              style({ opacity: 0 }),
              animate('500ms 1000ms ease-in-out',
                style({ opacity: 1 })),
            ], { optional: true }),
            // query('.preview', [
            //   style({ opacity: 0 }),
            //   animate('500ms 500ms ease-in-out',
            //     style({ opacity: 1 })),
            // ], { optional: true })
          ]),
        ])
      ], { optional: true })
    ])
  ])
]);

export const galleryTransition: AnimationTriggerMetadata = trigger('galleryTransition', [
  transition('void => *', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate("0.5s ease-in", style({ transform: 'translateX(0)', opacity: 1 }))
  ])
]);

export const alertDisplay = trigger('alertDisplay', [
  state('true', style({ height: 0 })),
  state('false', style({ height: '52px' })),
  transition('true => false', animate('100ms ease-in')),
  transition('true => false', animate('100ms ease-out'))
]);


// export const productsTransition: AnimationEntryMetadata = trigger('productsTransition', [
//   state('false', style({
//     height: 0
//   })),
//   query('.app-catalog-builder', style({ opacity: 0, left: '-5%' })),
//   transition('false => true', [
//     sequence([
//       query('.app-catalog-builder', animate(1000, style({ opacity: 1, left: '0' }))),
//       query('.app-ad-maker', animate(1000, style({ opacity: 1, left: '0' }))),
//       query('.app-academy', animate(1000, style({ opacity: 1, left: '0' })))
//     ]), animate('200ms ease-in')
//   ])
// ]);

// export const productsTransition: AnimationEntryMetadata = trigger('productsTransition', [
//   transition(':enter', [
//     query('.app-catalog-builder', [
//       style({ position: 'absolute', left: '0' }),
//       animate('200ms 500ms ease-in-out', style({ left: '100%' })),
//     ]),
//     // sequence([
//     //   query('.row:nth-child(2)', [
//     //     transition('void => *', [
//     //         style({ transform: 'translateX(-100%)', opacity: 0 }),
//     //         animate("0.5s ease-in", style({ transform: 'translateX(0)', opacity: 1 }))
//     //     ])
//     //   ]),
//     //   query('.row:nth-child(3)', [
//     //     transition('void => *', [
//     //         style({ transform: 'translateX(100%)', opacity: 0 }),
//     //         animate("0.5s ease-in", style({ transform: 'translateX(0)', opacity: 1 }))
//     //     ])
//     //   ]),
//     // ])
//   ])
// ]);


// Component transition animations
export const fadeInOutAnimation: AnimationTriggerMetadata =
  trigger('fadeInOutAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate(500, style({ opacity: 1 }))
    ]),
    transition(':leave', [
      animate(250, style({ opacity: 0 }))
    ])
  ])

// Component transition animations
export const fadeInOutAnimationWithDelay: AnimationTriggerMetadata =
  trigger('fadeInOutAnimationWithDelay', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate("0.5s 1s", style({ opacity: 1 }))
    ]),
    transition(':leave', [
      animate(250, style({ opacity: 0 }))
    ])
  ])

export const savingButtonAnimation: AnimationTriggerMetadata =
  trigger('savingButtonAnimation', [
    state('',
      style({
        backgroundColor: '#0c3e52',
        borderColor: '#0c3e52'
      })
    ),
    state('saving',
      style({
        backgroundColor: '#0e78d2',
        borderColor: '#0e78d2'
      })
    ),
    state('saved',
      style({
        backgroundColor: '#35d675',
        borderColor: '#35d675'
      })
    ),
    state('failed',
      style({
        backgroundColor: '#e6292f',
        borderColor: '#e6292f'
      })
    ),
    transition('* => *', [
      animate(500)
    ])
  ])